exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#inner-wrapper[data-v-313fad12] {\n  padding-left: 0;\n  padding-right: 0;\n}", ""]);

// exports
